import { ProductGallery } from './np-gallery.js';
import './np-klarna.js';
if (!customElements.get('np-product-page')) {
  class NuitProductPage extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const {signal} = this.events;
      const get = s => this.querySelector(s);
      const list = s => Array.from(this.querySelectorAll(s));
      const source = get('[data-source]');
      if (!source?.options.length) return;
      const variants = [...source.options].map(opt => ({
        id:opt.value, color:opt.dataset.color, size:opt.dataset.size, weight:opt.dataset.weight,
        cents:Number(opt.dataset.cents), money:opt.dataset.money, stock:opt.dataset.stock === 'true', onHand:Number(opt.dataset.onHand)||0, image:opt.dataset.image
      }));
      const photos = list('[data-photo]');
      const thumbnails = list('[data-thumb]');
      const stage = get('.npp-stage');
      const gallery = new ProductGallery(stage,{photos,thumbs:thumbnails,caption:get('[data-photo-caption]'),count:get('[data-photo-count]'),signal});
      this.gallery=gallery;
      const showPhoto=(i,options)=>gallery.show(i,options);
      const urlVariant = new URL(location.href).searchParams.get('variant');
      let current = variants.find(v=>v.id===urlVariant) || variants.find(v=>v.id===source.value) || variants[0];
      const initialPhoto = photos.findIndex(p=>p.dataset.photo===current.image);
      if (urlVariant && initialPhoto >= 0) showPhoto(initialPhoto,{instant:true});
      let pair = false;
      const bundleRate = Math.min(100, Math.max(0, Number(this.dataset.bundleRate) || 0));
      const second = get('[data-second]');
      second.replaceChildren();
      [...source.options].forEach(opt=>second.add(opt.cloneNode(true)));
      second.value = current.id;
      const idField = get('[data-current-id]');
      const walletQuantity = get('[data-wallet-quantity]');
      const liveWallet = get('[data-wallet-live]');
      source.removeAttribute('name'); idField.name = 'id'; get('[data-plain]').hidden = true;
      list('[data-enhance]').forEach(el=>el.hidden=false);
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR',{style:'currency',currency:this.dataset.currency||'EUR'});
      const button = (label,key,value,host) => {
        const b=document.createElement('button'); b.type='button'; b.dataset[key]=value; b.textContent=label; host.append(b); return b;
      };
      get('[data-colors]').replaceChildren();
      const colors = new Set(variants.map(v=>v.color));
      get('[data-color-options]').hidden = colors.size < 2;
      for(const color of colors) {
        const b=button(color,'pickColor',color,get('[data-colors]')); const dot=document.createElement('i');
        dot.setAttribute('aria-hidden','true'); dot.style.background=color.toLowerCase()==='noir'?'#29272b':'#92908f';b.prepend(dot);
      }
      const update = () => {
        source.value=current.id;
        const variantChanged = idField.value !== current.id;
        idField.value=current.id;
        get('[data-color-name]').textContent=current.color;
        list('[data-pick-color]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pickColor===current.color)));
        const host=get('[data-weights]'); const active=document.activeElement;
        const activeVariant=host.contains(active)?active.dataset.pickVariant:null;
        host.replaceChildren();
        const colorVariants = variants.filter(v=>v.color===current.color);
        get('[data-variant-options]').hidden = colorVariants.length < 2;
        colorVariants.sort((a,b)=>parseFloat(a.weight)-parseFloat(b.weight)||parseFloat(a.size)-parseFloat(b.size)).forEach(v=>{
          const b=button(v.weight,'pickVariant',v.id,host); const dimension=document.createElement('small');dimension.textContent=v.size;b.append(dimension);b.setAttribute('aria-pressed',String(v.id===current.id));
          if (v.id===activeVariant) b.focus({preventScroll:true});
        });
        const other=variants.find(v=>v.id===second.value)||current;
        const subtotal=pair?current.cents+other.cents:current.cents;
        const total=pair?Math.round(subtotal*(100-bundleRate)/100):subtotal;
        const sum=pair?formatter.format(total/100):current.money;
        get('[data-unit]').textContent=current.money; get('[data-total]').textContent=sum; get('[data-sticky-price]').textContent=sum;
        get('[data-base-total]').textContent=formatter.format(subtotal/100);
        get('np-klarna')?.setAmount(total);
        get('[data-base-total]').hidden=!pair;
        get('[data-saving-money]').textContent=formatter.format((subtotal-total)/100);
        get('[data-savings]').hidden=!pair;
        get('[data-ref="add-to-cart-button-container"]').dataset.price=current.cents;
        const locked=this.dataset.preview==='true'; const available=current.stock&&(!pair||other.stock);
        get('[data-ref="add-to-cart-button"]').disabled=locked||!available;
        const mixed = pair && second.value !== current.id;
        const quantity = pair && !mixed ? '2' : '1';
        const quantityChanged = walletQuantity.value !== quantity;
        walletQuantity.value = quantity;
        if (mixed) second.name = 'items[1][id]'; else second.removeAttribute('name');
        if (liveWallet) liveWallet.hidden = locked || !available || mixed;
        get('[data-wallet-note]').hidden = !mixed;
        if (variantChanged) idField.dispatchEvent(new Event('change', {bubbles:true}));
        if (quantityChanged) walletQuantity.dispatchEvent(new Event('change', {bubbles:true}));
        const stockBadge=get('[data-stock-status]');
        if(stockBadge){
          const onHand=pair?(second.value===current.id?current.onHand>=2:current.onHand>0&&other.onHand>0):current.onHand>0;
          const state=locked||!available?'unavailable':onHand?'in-stock':'available';
          stockBadge.dataset.state=state;
          get('[data-stock-label]').textContent=stockBadge.dataset[state==='in-stock'?'inStock':state];
        }
        get('[data-variant-size]').textContent=current.size;
        get('[data-buy-label]').textContent=locked?'Indisponible à la commande':available?'Ajouter au panier':'Épuisé';
        get('[data-second-wrap]').hidden=!pair || variants.length < 2;
        list('[data-qty]').forEach(b=>b.setAttribute('aria-pressed',String((b.dataset.qty==='2')===pair)));
        this.updateShortcut?.();
      };
      const choose = v => {
        if (!v) return;
        const previous=current;current=v;
        if (!pair && second.value===previous.id) second.value=v.id;
        const pic=photos.findIndex(p=>p.dataset.photo===v.image);
        if(pic>=0 && (v.color!==previous.color || v.image!==previous.image)) showPhoto(pic);
        const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(history.state,'',url);update();
      };
      this.addEventListener('click',e=>{
        const b=e.target.closest('button');if(!b) return;
        if(b.hasAttribute('data-thumb'))showPhoto(photos.findIndex(p=>p.dataset.photo===b.dataset.thumb));
        if(b.hasAttribute('data-prev'))showPhoto(gallery.index-1,{direction:-1});
        if(b.hasAttribute('data-next'))showPhoto(gallery.index+1,{direction:1});
        if(b.dataset.pickVariant) choose(variants.find(v=>v.id===b.dataset.pickVariant));
        if(b.dataset.pickColor){const opts=variants.filter(v=>v.color===b.dataset.pickColor);choose(opts.find(v=>v.size===current.size&&v.weight===current.weight)||opts.find(v=>v.weight===current.weight)||opts.find(v=>v.stock)||opts[0]);}
        if(b.dataset.qty){pair=b.dataset.qty==='2';update();}
      },{signal});
      second.addEventListener('change',update,{signal});
      const form=get('form');
      form?.addEventListener('submit',e=>{
        if (get('[data-ref="add-to-cart-button"]').disabled) {e.preventDefault();e.stopImmediatePropagation();}
      },{capture:true,signal});
      // FullStack posts the primary ID and any additional indexed items in one cart request.
      if(this.dataset.preview==='true') get('[data-bundle]').hidden=false;
      customElements.whenDefined('product-form').then(()=>{if(!signal.aborted)get('[data-bundle]').hidden=false;});
      const sticky=get('[data-sticky]');
      const updateShortcut=()=>{
        const panel=get('.npp-panel').getBoundingClientRect(),buttonRect=get('[data-ref="add-to-cart-button"]').getBoundingClientRect();
        const inPanel=panel.top<innerHeight-80&&panel.bottom>70;
        const buttonVisible=buttonRect.top<innerHeight&&buttonRect.bottom>70;
        sticky.hidden=!inPanel||buttonVisible;
      };
      let shortcutFrame;
      const scheduleShortcut=()=>{if(shortcutFrame)return;shortcutFrame=requestAnimationFrame(()=>{shortcutFrame=null;updateShortcut();});};
      window.addEventListener('scroll',scheduleShortcut,{passive:true,signal});
      window.addEventListener('resize',scheduleShortcut,{signal});
      this.stopShortcut=()=>cancelAnimationFrame(shortcutFrame);
      this.updateShortcut=scheduleShortcut;
      updateShortcut();
      update();
    }
    disconnectedCallback(){this.gallery?.destroy();this.stopShortcut?.();this.events?.abort();this.events=null;this.watcher?.disconnect();}
  }
  customElements.define('np-product-page',NuitProductPage);
}
